import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

type BecomeSellerCTAProps = {
  route?: string;
  standalone?: string;
};

const BecomeSellerCTA: React.FC<BecomeSellerCTAProps> = ({ route, standalone }) => {
  const { width } = useWindowDimensions();
  const tooltip = width > 767 && width < 992;
  const isStandalone = standalone === 'true';

  return (
    <>
      { tooltip && !isStandalone ? (
        <OverlayTrigger
          placement="right"
          trigger={['click']}
          overlay={(
            <Tooltip
              id="become-seller-cta-tooltip"
            >
              <div className="p-2">
                <span>Looking to sell puppies?</span>

                <a className="btn btn-primary btn-sm mt-3 px-3" href={route}>
                  Become a Seller
                </a>
              </div>
            </Tooltip>
          )}
        >
          <ul className="menu list-unstyled mb-0">
            <li className="menu-item">
              <a type="button" className="btn">
                <i className="fa fa-info-circle menu-item-icon" />
              </a>
            </li>
          </ul>
        </OverlayTrigger>
      ) : (
        <div className="become-seller-cta m-3 mt-0 p-3">
          <span>Looking to sell puppies?</span>

          <a className="btn btn-primary btn-sm mt-3 px-3" href={route}>
            Become a Seller
          </a>
        </div>
      )}
    </>
  );
};

export default BecomeSellerCTA;

document.querySelectorAll('.become-seller-cta-container').forEach((element) => {
  const route = element.getAttribute('data-route') ?? undefined;
  const standalone = element.getAttribute('data-standalone') ?? undefined;
  ReactDOM.render(<BecomeSellerCTA route={route} standalone={standalone} />, element);
});
